import { MainTemplate } from "@/components/templates";
import { PageTitle } from "@/components/molecules";
import { css } from "@emotion/react";
import { color } from "@/styles/theme";
import { Button, CheckBox } from "@moneyforward/mfx_biz_react_components";
import React, { useState, ChangeEvent } from "react";
import { useAcceptCompanyWithdrawalMutation } from "@/generated/graphql";
import Router from "next/router";
import useRollbarUtil from "../hooks/useRollbarUtil";

export const AcceptCompanyWithdrawalPage = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const [accepted, setAccepted] = useState<boolean>(false);

  const hundleAcceptChange = (event: ChangeEvent<HTMLInputElement>) => {
    setAccepted(event.target.checked);
  };

  const [
    acceptCompanyWithdrawalMutation,
    { loading: companyWithdrawalLoading },
  ] = useAcceptCompanyWithdrawalMutation({
    onCompleted: (data) => {
      if (data.acceptCompanyWithdrawal.result) {
        Router.push("/accept-company-withdrawal-completed");
      }
    },
    onError: getNotifyErrorHandlerForGraphQL(
      "Failed to accept company withdrawal"
    ),
  });

  const onClickDelete = () => {
    acceptCompanyWithdrawalMutation();
  };

  return (
    <MainTemplate title={`Mikatano シリーズ退会手続き`}>
      <PageTitle
        mainTitle={`Mikatano シリーズ退会手続き`}
        subTitle={`Mikatano シリーズ全てのサービスの利用を終了します。`}
      />
      <div css={container}>
        <div css={box}>
          <p css={msgTitle}>退会前に必ずご確認ください。</p>
          <div css={msgContainer}>
            <div css={msgBox}>
              <ul css={ul}>
                <li>
                  Mikatano
                  ID退会手続を行うと、ご所属の事業者に登録されている利用者全員がMikatano
                  シリーズ全てのサービスをご利用できなくなります。
                </li>
                <li>
                  退会後も必要なデータは、退会前にデータのバックアップを行ってください。当社ではデータの復旧は承っていませんので、十分ご注意ください。
                </li>
                <li>
                  ご利用中のMikatano
                  シリーズの一部サービスのみ解約する場合は、Mikatano
                  プランの変更または解約を行ってください。
                </li>
                <li>
                  退会時期に関わらず、利用料金の返金はございません。また、退会した月の月額利用料全額のお支払いが発生しますので、ご了承ください。
                  <br />
                  <span css={example}>
                    例：3月10日に退会した場合、3月分の月額利用料全額のお支払いが必要になります。
                    <br />
                    　　なお、3月分の月額利用料のご請求は4月となります。
                  </span>
                </li>
                <li>
                  Mikatano IDの退会後にあらためてMikatano
                  シリーズをご利用になる場合、再度、利用開始の手続が必要となります。なお、この場合でも、退会前のデータは復元又は引継ぎはされませんので、ご了承ください。
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div css={form}>
        <CheckBox
          label="注意事項に同意します"
          onChange={hundleAcceptChange}
          checked={accepted}
        ></CheckBox>
      </div>
      <div css={button}>
        <Button
          variant="destructive"
          onClick={onClickDelete}
          disabled={!accepted || companyWithdrawalLoading}
        >
          退会
        </Button>
      </div>
    </MainTemplate>
  );
};

const container = css({
  margin: "0",
  padding: "0",
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  minHeight: "80px",
  padding: "40px 32px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const msgTitle = css({
  color: "#D32F2F",
  fontSize: "16px",
  fontFamily: "Hiragino Kaku Gothic Pro",
  fontWeight: "600",
  marginTop: "-10px",
});

const msgContainer = css({
  backgroundColor: "#F1F3F4",
});

const msgBox = css({
  padding: "20px 0",
});

const ul = css`
  li {
    list-style-type: none;
    counter-increment: cnt;
    text-indent: -1em;
    padding-right: 24px;
  }
  li::before {
    content: "・";
  }
`;

const form = css({
  marginTop: "20px",
  display: "flex",
  justifyContent: "center",
});

const button = css({
  marginTop: "20px",
  display: "flex",
  justifyContent: "center",
});

const example = css({
  fontSize: "12px",
});
